export default "__VITE_ASSET__AaC7O7P7__"